/**
 * Modul Projekti: delitev amortizacije po projektih (docs/ARHITEKTURA.md, 15).
 * Tu je sifrant projektov in nastavitve modula (1. del).
 */
/** Koda modula v `reference/moduli.csv`. */
export const MODUL_PROJEKTI = 'projekti';
/** Privzeto najvec projektov na enem sredstvu; nastavitev podjetja. */
export const PRIVZETO_NAJVEC_PROJEKTOV = 6;
// ---------------------------------------------------------------------------
// 5. del: pregledi za stranko (docs/ARHITEKTURA.md, 15.5)
// ---------------------------------------------------------------------------
/** Pogledi glavnega zavihka Projekti (podzavihki). */
export const POGLEDI_PROJEKTOV = ['pregled', 'po-projektih', 'poraba', 'odstotki'];
//# sourceMappingURL=projekti.js.map